import TripModule from '../TripModule';
import type Ship from '@itinerary/trip/ship/Ship';
import type ShipPriceClass from '@itinerary/trip/ship/ShipPriceClass';
import { type Filter } from '@itinerary/ItineraryModuleTypes';
import { type ReserveType } from '@utils/itinerary';
import { type TripPackageLoaderConfig } from '@itinerary/trip/types';
import { type TripFilters } from '@itinerary/trip/TripModuleTypes';
import type TripPackage from '@itinerary/trip/TripPackage';
import type TripPackageSet from '@itinerary/trip/TripPackageSet';

export default class ShipModule extends TripModule<Ship, ShipPriceClass> {
    override getInitialFilters(): { '': any } {
        throw new Error('The method is not implemented.');
    }

    override getPackageSet(
        _loaderConfig: TripPackageLoaderConfig
    ): TripPackageSet<
        TripFilters['meta'],
        TripFilters['key'],
        TripPackage<Ship, ShipPriceClass>
    > {
        throw new Error('Not implemented');
    }

    override get reserveInfo() {
        return useShipForm().reserveInfo;
    }

    override getItineraryPackageLoaderConfigs(): TripPackageLoaderConfig[] {
        throw new Error('The method is not implemented.');
    }

    override get defaultSortBy(): string {
        throw new Error('The method is not implemented.');
    }

    override get metaTagTitle(): string {
        throw new Error('The method is not implemented.');
    }

    override get descriptionTemplate(): string {
        throw new Error('The method is not implemented.');
    }

    override formAutoReserve(): Promise<void> {
        throw new Error('The method is not implemented.');
    }

    override get filters(): Filter[] {
        throw new Error('The method is not implemented.');
    }

    override applyFilter(): boolean {
        throw new Error('The method is not implemented.');
    }

    override get alternativeSuggestionTypes(): [ReserveType, ReserveType] {
        throw new Error('Operation is not supported!');
    }

    override loadSuggestions(): void {
        throw new Error('The method is not implemented.');
    }
}
